import { FC } from 'react';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useProductList } from '@/components/EcoCredits/api';
import EditorLink from 'lowcode/components/EditorLink';
import EditorImg from 'lowcode/components/EditorImg';
import { IPageStatus, ProductModule } from '@/components/EcocreditsMonthlyMadness/type';
import { useLang } from '@/app/utils/useLang';
import Header from '@/components/EcoCredits/CommonElement/Header';
import { useGlobal } from '@/utils/useGlobal';
import { useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';

type IProps = {
    title: string;
    id?: string;
    desc?: string;
    module: ProductModule;
};

const euList: { pc: string; h5: string }[] = [
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1730885430381/hotpick_1_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1730885433695/hotpick_2_m.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1730885581734/hotpick_2_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1730885585492/hotpick_1_m.jpg',
    },
    {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1730885731703/hotpick_3_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1730885735117/hotpick_3_m.jpg',
    },
];

const imgList: Record<string, { pc: string; h5: string }[]> = {
    eu: euList,
    uk: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730887456811/hotpick_1_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730887460962/hotpick_1_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730887481272/hotpick_2_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730887484566/hotpick_2_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730887541155/hotpick_3_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730887545001/hotpick_3_m.jpg',
        },
    ],
    es: euList,
    it: euList,
    de: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730885430381/hotpick_1_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730885433695/hotpick_2_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1730885581734/hotpick_2_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1730885585492/hotpick_1_m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731916906042/20241118-150706.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731916906042/20241118-150706.jpg',
        },
    ],
    fr: euList,
};

const activityTime = {
    start: new Date('2024/11/19 16:00:00 GMT+8').getTime(),
    end: new Date('2024/12/03 16:00:00 GMT+8').getTime(),
};

const EUProduct2: FC<IProps> = ({ title, desc, id, module }) => {
    const { locale } = getLocal();
    const { pageStatus } = useMonthlyStore();
    const { productList } = useProductList(module, locale);
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const { t } = useLang('appreciationday');

    const isLimited = systemTime >= activityTime.start && systemTime <= activityTime.end;

    const picList = imgList[locale];

    const urlCollections: Record<string, string> = {
        eu: 'https://eu.ecoflow.com/pages/black-friday-sale',
        uk: 'https://uk.ecoflow.com/pages/black-friday-sale',
        it: 'https://it.ecoflow.com/pages/black-friday-sale',
        es: 'https://es.ecoflow.com/pages/black-friday-sale',
        fr: 'https://fr.ecoflow.com/pages/black-friday-sale',
        de: 'https://de.ecoflow.com/pages/black-friday-sale',
    };

    console.log({ productList });

    if (!productList || productList.length === 0 || (pageStatus !== IPageStatus.ACTIVITY && !isLimited)) return <></>;

    return (
        <div className={`${styled.products_eu}`} id={id}>
            <Header title={title} desc={desc} />
            <div className="products_eu_container">
                {productList.map((item, i) => (
                    <div className="item_card" key={item.productId}>
                        <div className="card_img">
                            <EditorImg className="img" pc={picList[i]?.pc || item.imageUrl} h5={picList[i]?.h5 || item.imageUrl} />
                        </div>
                        <div className="card_text">
                            <div className="card_text_wrapper">
                                {locale !== 'uk' && i < 3 && <div className="card_tag">{t('product_tag')}</div>}
                                <div className="title">{item.title}</div>
                                {item.subtitle1 && <div className="subtitle1">{item.subtitle1}</div>}
                                {item.subtitle2 && <div className="subtitle1">{item.subtitle2}</div>}
                            </div>
                            <div className="context_price">
                                <div className="price_1">{item.memberPrice2}</div>
                                {item.compareAtPrice2 && item.compareAtPrice2 !== item.memberPrice2 && <div className="price_2">{item.compareAtPrice2}</div>}
                            </div>
                            <div className="button_action">
                                <EditorLink href={item.productUrl} target="_blank">
                                    <button className="button_learn_more">{t('learn_more')}</button>
                                </EditorLink>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="bottom_link">
                <EditorLink href={urlCollections[locale]} target="_blank">
                    <div className="shop_link">{t('shop_link_text')}</div>
                </EditorLink>
            </div>
        </div>
    );
};

export default EUProduct2;
